<template>
    <div class="container">
        <div class="title">{{ title }}</div>
        <div class="details">
            <div class="text" v-if = "isAI && aiText">{{ aiText }}</div>
            <div class="text1" v-else>{{  text }}</div>
        </div>
      <div class="ai-logo" v-if = "isAI && aiText">
        <img style="width: 12px; height:12px;" :src="require('@/assets/ai-slogo.png')" alt="AI标识"/>
      </div>
    </div>
  </template>
<script>

export default {
  name: "ai-two-display-row",
  props: {
    title: {
      type: String
    },
     aiText: {
      type: [Object, Array, String, Number, Boolean]
    },
    text: {
      type: String
    },

    isAI: {
      type: Boolean
    },
    
  },
  data() {
    return {
    
    };
  },
  mounted() {},
  methods: {}
};

</script>
<style>
.container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
}

.title {
    margin-top: 15px;
}

.details {
    display: flex;
    align-items: flex-start;
    /* background-color: #e6f7ff; */
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.ai-logo {
    color: white;
    width: 18px;
    height: 18px;
    background: #7788FF;
    border-radius: 2px;
    font-weight: 500;
    font-size: 12px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
}

.text1 {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    /* white-space: nowrap; */
    white-space: pre-line;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    border-radius: 2px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
}
.text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    /* white-space: nowrap; */
    white-space: pre-line;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #000000;
    background: rgba(119,136,255,0.3);
    line-height: 20px;
    border-radius: 2px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
}
</style>